import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import backk from './images/backk.png';

function DetailedTime() {
  const { personName } = useParams();
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = () => {
    if (fromDate && toDate) {
      navigate(`/report/${personName}?fromDate=${fromDate}&toDate=${toDate}`);
    } else {
      setError('Please select both From Date and To Date');
    }
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div
      style={{
        background: 'linear-gradient(to bottom, #fff7ad, #ffa9f9)',
        minHeight: '100vh',
        padding: '20px',
      }}
    >
      <h2 style={{ color: '#E11584' }}>Details of {personName}</h2>
      <label style={{ color: '#E11584' }}>
        From Date:
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />
      </label>
      <br />
      <br />
      <label style={{ color: '#E11584' }}>
        To Date:
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </label>
      <br />
      <br />
      <button
        onClick={handleSubmit}
        style={{
          backgroundColor: '#E11584',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
        }}
      >
        View Report
      </button>
      <br />
      <br />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button onClick={handleBackClick}>
        <img src={backk} width="40" height="40" alt="Back" />
      </button>
    </div>
  );
}

export default DetailedTime;
